import { render, staticRenderFns } from "./LeftTextSelect.vue?vue&type=template&id=c68ae768"
import script from "./LeftTextSelect.vue?vue&type=script&lang=js"
export * from "./LeftTextSelect.vue?vue&type=script&lang=js"
import style0 from "./LeftTextSelect.vue?vue&type=style&index=0&id=c68ae768&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports